<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title" id="ack"><a id="pagevii" title="vii">Acknowledgements</a></h2><a id="pagevii" title="vii">
<p class="noindent">This book is dedicated to all those who helped.</p>
<p class="indent">There were so many, but I must mention in particular:</p>
<p class="indent">‘Jim’ Ozawa, who when we regularly refought the Pacific War together, many years ago now, first introduced and explained to me the actions and motives of the Kamikaze organizers and pilots.</p>
<p class="indent">David Mattiske, Maya Sieber and Simon Thayer, who between them recently revived my interest in this subject.</p>
<p class="indent">My agents Johnson &amp; Alcock Limited, especially my helpful and encouraging liaison officer Ed Wilson.</p>
<p class="indent">My knowledgeable and industrious editor Pamela Covey.</p>
<p class="indent">The Birmingham &amp; Midland Institute &amp; Library, the Taylor Library and the US Navy Department of Information who assisted with the photographs.</p>
<p class="indent">Brigadier Henry Wilson and the staff of my publishers Pen &amp; Sword Books Limited, especially Jon Wilkinson who sorted out the jacket, Dominic Allen who sorted out the plates, ‘SJ’ who sorted out the maps and the ever-patient Matt Jones and Laura Hirst who sorted out everything else.</p>
</a><p class="indent"><a id="pagevii" title="vii">I’m very lucky and I’m very grateful.</a><a id="pageviii" title="viii"></a></p><a id="pageviii" title="viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Acknowledgement.vue?69b72812